import { type DocumentTypeValue } from 'features/documents/types';
import { z } from 'zod';

import sharedMsg from '../../messages';

import { FR_DECLARATIONS } from './components/steps/declaration-step/frDeclarations';
import { FR_DOCUMENTS } from './frDocuments';

import type {
  PageSchemaFactory,
  PageSchemaMap,
} from 'features/charity-vetting/common-flow/validation/pageSchemaRegistry';

const wrap = (charityOnboarding: z.ZodTypeAny) => z.looseObject({ charityOnboarding });

const declarationPageSchema =
  (field: 'hasFoodSafetyManagementPlan' | 'hasHaccpProcedures'): PageSchemaFactory =>
  () =>
    wrap(z.looseObject({ [field]: z.literal(true) }));

const documentPageSchema =
  (documentType: DocumentTypeValue): PageSchemaFactory =>
  (formatMessage) =>
    wrap(
      z
        .looseObject({
          vettingDocuments: z.record(z.string(), z.unknown()).optional(),
        })
        .superRefine((data, ctx) => {
          if (!data.vettingDocuments?.[documentType]) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: formatMessage(sharedMsg.charityVettingDocumentRequiredError),
              path: ['vettingDocuments', documentType],
            });
          }
        }),
    );

export const frDocumentPageSchemas: PageSchemaMap = {
  ...Object.fromEntries(
    FR_DOCUMENTS.filter(({ isMandatory }) => isMandatory).map(({ segment, documentType }) => [
      segment,
      documentPageSchema(documentType),
    ]),
  ),
  ...Object.fromEntries(
    FR_DECLARATIONS.map(({ segment, field }) => [segment, declarationPageSchema(field)]),
  ),
};
